class Entity
	constructor: (@property, @type, @exclude = false) ->
		if !@getTypes().includes(@type)
			throw new Error("Relation type '#{@type}' is invalid. Valid types are #{@getTypes().join(', ')}")

	toJSON: ->
		if @exclude == false && @type == 'simple'
			return @property

		return @

	getTypes: ->
		# @see PHP class ActiveRecordRelationTreeItem::getValidTypes
		return ['full', 'id', 'simple']
